import * as CryptoJS from 'crypto-js';
import { clientConfig } from '../utilities/configService';

export const useFetchWrapper = () => {

    const request = (requestMethod: string) => {
        return (endpoint: string, contentType: string = 'text/plain', body: any = null, isFileDownload: boolean = false) => {

            const theEndPoint = endpoint.trim() !== "" ? endpoint.trim().toLowerCase() : "";
            //environment values
            const proxUrl: string = import.meta.env.REACT_APP_API_PROXY_URL as string;
            const path: string = import.meta.env.REACT_APP_API_PATH as string;

            //application values
            const clientInstance: string = clientConfig?.CLIENT_INSTANCE || '';  //clientApplicationConfig.CLIENT_INSTANCE;
            const platformName: string = clientConfig?.PLATFORM_NAME || ''; //clientApplicationConfig.PLATFORM_NAME;

            var url = proxUrl + path + '/' + theEndPoint;
            const requestHeaders = new Headers();
            requestHeaders.append("X-Application-Name", platformName);
            requestHeaders.append("X-Application-Instance", clientInstance);
            let date = new Date();
            requestHeaders.append("X-Timestamp", date.toUTCString());

            var payload = body || {};
            const signature = generateSignature(requestMethod, url, requestHeaders, payload);
            requestHeaders.append("X-HTTP-Signature", signature);
            var request = new Request(url);

            if (body) {
                requestHeaders.append("Content-Type", contentType);

                request = new Request(url, {
                    method: requestMethod,
                    headers: requestHeaders,
                    body: JSON.stringify(body)
                });
            }
            else {
                request = new Request(url, {
                    method: requestMethod,
                    headers: requestHeaders
                });
            }
            if (isFileDownload) {
                return fetch(request).then(handleBlobResponse);
            }
            return fetch(request).then(handleResponse);
        }
    }

    const generateSignature = (method: string, url: string, headers: Headers, payload: string|null) => {
        const signature = CryptoJS.SHA256(`${method}${url}${JSON.stringify(headers)}${JSON.stringify(payload)}`).toString(CryptoJS.enc.Base64);
        return signature;
    };

    const handleResponse = (response: { text: () => Promise<any>; ok: any; status: number; statusText: any; }) => {
        return response.text().then(text => {

            if (!response.ok) {
                const error = (text) || response.statusText;
                return Promise.reject(error);
            }
            else {
                const data = text && JSON.parse(text);
                return data;
            }
        });
    }

    const handleBlobResponse = (response: { blob: () => Promise<any>; ok: any; status: number; statusText: any; }) => {
        //return response.blob();
        return response.blob().then(blob => {
            const data = blob;

            if (!response.ok) {
                const error = (data && data.message) || response.statusText;
                return Promise.reject(error);
            }
            return data;
        });
    }



    return {
        get: request('GET'),
        post: request('POST'),
        put: request('PUT'),
        delete: request('DELETE')
    };


}